// extracted by mini-css-extract-plugin
export var container = "arnes-module--container--5w2HU";
export var img = "arnes-module--img--FMt9P";
export var nuevo = "arnes-module--nuevo---v90G";